module.exports = __webpack_public_path__ + "static/media/jcb.b183ef27.svg";